// extracted by mini-css-extract-plugin
module.exports = {"root":"s_b","title":"s_S","last":"s_T","left":"s_l","dateRow":"s_V","icon":"s_W","date":"s_X","same":"s_Y","image":"s_Z","dividerAnimation":"s_p"};